export enum PaymentStatus {
  GENERATED_INVOICE = 'NEW',
  PAID_THEME = 'APROVED',
  INVOICE_CANCELED = 'CANCELED',
  THEME_FOR_SALE = 'PENDING',
  GENERATED_INVOICE_2 = 'DOWN_PAYMENT',
}
